import React from 'react';
import { UsersIcon } from 'lucide-react';
const SPOTS_LEFT = 17;
const TOTAL_SPOTS = 250;
export function ScarcityBar() {
  const claimed = TOTAL_SPOTS - SPOTS_LEFT;
  const percent = Math.round(claimed / TOTAL_SPOTS * 100);
  return <div className="w-full rounded-2xl border border-brick-200 bg-brick-50 p-4 sm:p-5" data-id="element-51" data-mp="2l4eji1ulysjc">
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1" data-id="element-52" data-mp="2q2ptcckwl31k">
        <p className="flex items-center gap-1.5 text-[13px] font-extrabold uppercase tracking-wide text-brick-700 sm:text-sm" data-id="element-53" data-mp="2b5p187ysv62k">
          <UsersIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="2g74o85kjfmnl" />
          Only {SPOTS_LEFT} spots left at $27
        </p>
        <p className="text-[12px] font-bold text-navy-500 sm:text-[13px]" data-id="element-55" data-mp="228eqcnpw9iy6">{percent}% claimed</p>
      </div>
      <div className="mt-2.5 h-3 w-full overflow-hidden rounded-full bg-white ring-1 ring-inset ring-brick-200" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label={`${percent} percent of promotional spots claimed`} data-id="element-56" data-mp="276zpejtetwl1">
        <div className="h-full rounded-full bg-brick-600" style={{
        width: `${percent}%`
      }} data-id="element-57" data-mp="2zljdu4cli7ss" />
      </div>
      <p className="mt-2.5 text-[12px] font-medium leading-relaxed text-navy-600 sm:text-[13px]" data-id="element-58" data-mp="3dbmvsj4fzfcf">
        {claimed} of {TOTAL_SPOTS} promotional spots have been taken. When they run out, the price
        returns to $97.
      </p>
    </div>;
}